import { uuid } from '@/helpers/uuid';

const CommonInputAttributes = {
  data() {
    return {
      currentValue: this.modelValue,
      isFocused: false,
      valueWhenFocus: null,
    };
  },

  watch: {
    currentValue(currentValue) {
      this.$emit('update:modelValue', currentValue);
    },

    modelValue(value) {
      this.currentValue = value;
    },
  },

  props: {
    modelValue: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    reset: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    minlength: {
      type: [String, Number],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: undefined,
    },
    pattern: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: null,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    optionalLabel: {
      type: String,
      default: null,
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
    lazyUpdate: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: String,
      default: null,
    },
    shake: {
      type: Boolean,
      default: false,
    },
    descriptionLabel: {
      type: String,
      default: null,
    },
  },

  computed: {
    getId() {
      return this.id || uuid();
    },
  },

  methods: {
    onBlur(e) {
      this.$emit('blur', e);
      this.currentValue = e.target.value;
      if (this.currentValue !== this.valueWhenFocus) {
        this.$emit('change', this.currentValue);
      }
      this.isFocused = false;
    },
    onFocus(e) {
      this.$emit('focus', e);
      this.valueWhenFocus = this.currentValue;
      this.isFocused = true;
    },
    onInput(e) {
      if (!this.lazyUpdate) {
        this.currentValue = e.target.value;
      }
    },
    onKeyDown(e) {
      this.$emit('keydown', e);

      // Reactive v-model binding for Vuelidate when Enter submits the form.
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        this.currentValue = e.target.value;
      }
    },
    blur() {
      this.$el.blur();
    },
    click() {
      this.$el.click();
    },
    focus() {
      this.$el.focus();
    },
    select() {
      this.$el.select();
    },
    setSelectionRange() {
      this.$el.setSelectionRange();
    },
    setRangeText() {
      this.$el.setRangeText();
    },
  },
};

export default CommonInputAttributes;
